// extracted by mini-css-extract-plugin
export var activeFilterButton = "_kk-c";
export var backButton = "_kk-4";
export var backIcon = "_kk-5";
export var chevronShortcut = "_kk-6";
export var container = "_kk-1";
export var editor = "_kk-8";
export var editorWrapper = "_kk-7";
export var prefix = "_kk-2";
export var searchIcon = "_kk-3";
export var suffix = "_kk-9";
export var suffixContent = "_kk-a";
export var suffixText = "_kk-b";
export var wrapper = "_kk-0";